module.exports = __webpack_public_path__ + "static/img/law-section3-1.460d45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/law/law-section3-1.png
// module id = 463
// module chunks = 12